import { UpdateAPIUserManagerPermissions, UserManagerPermissions, UserManagerRoleCatalogNodePermissions } from "@medapro-types/UserManager/UserManager";
import api from "./api";
import endpoints from "./endpoints";

export default {
  get: async function (roleId: string, language: string): Promise<UserManagerPermissions> {
    const response = await api.get(endpoints.permissions.get, { params: { roleId, language } });
    return response.data;
  },
  getCatalogNodePermissions: async function (roleId: string, catalogId: string, language: string): Promise<UserManagerRoleCatalogNodePermissions[]> {
    const response = await api.get(endpoints.permissions.getCatalogNodePermissions, { params: { roleId, catalogId, language } });
    return response.data;
  },
  update: async function (permissions: UpdateAPIUserManagerPermissions): Promise<string> {
    const response = await api.post(endpoints.permissions.update, permissions);
    return response.data;
  }
};
